export class RegionModel {
  id!: number | 0;
  name!: string | '';
  regionNumber: string | null;
  areas: AreaModel[];
}

export class AreaModel {
  id!: number | 0;
  name!: string | '';
  region? = {} as RegionModel;
}
